import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    marginTop: 20,
    marginBottom: 20,
    color: 'grey'
  }
}));
